export const PRIVATELY_OWNED = "PRIVATELY_OWNED";
export const PUBLICLY_TRADED = "PUBLICLY_TRADED";
export const GOVERNMENT_OWNED = "GOVERNMENT_OWNED";

export const ownershipTypesDisplay = {
  [PRIVATELY_OWNED]: "Privately Owned",
  [PUBLICLY_TRADED]: "Publicly Traded",
  [GOVERNMENT_OWNED]: "Government Owned",
};
